import { Box, keyframes } from "@mui/material";
import { accents } from "@themes/tokens/accents";

const livePulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.7;
  }

  100% {
    transform: scale(2.5);
    opacity: 0;
  }
`;

type PulsingDotSize = "small" | "medium";

const sizes: Record<PulsingDotSize, number> = {
  medium: 8,
  small: 5
};

interface Props {
  color?: string;
  size?: PulsingDotSize;
}

const DEFAULT_DOT_COLOR = accents.emerald;

export const PulsingDot = ({
  color = DEFAULT_DOT_COLOR,
  size = "small"
}: Props) => {
  const dotSize = sizes[size];

  return (
    <Box
      component="span"
      sx={{
        "&::after": {
          animation: `${livePulse} 1.6s ease-out infinite`,
          bgcolor: "inherit",
          borderRadius: "50%",
          content: '""',
          inset: 0,
          position: "absolute"
        },
        "@media (prefers-reduced-motion: reduce)": {
          "&::after": {
            animation: "none"
          }
        },
        bgcolor: color,
        borderRadius: "50%",
        display: "inline-block",
        height: dotSize,
        position: "relative",
        width: dotSize
      }}
    />
  );
};
